<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import moment from "moment";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Comandas",
            items: [
                {
                text: "Inicio",
                href: "/"
                },
                {
                text: "Comandas",
                active: true
                }
            ],
            pedidos:[],
            articulos:[],
            canales:[],
        };
    },
    methods:{
        get_data(){
            this.isLoading=true
            try {
                axios.get('/api/get_pedidos_dia')
                .then(response => {
                    this.pedidos = response.data;
                    this.pedidos = this.pedidos.filter(pedido=>pedido.estado=='Pagado' || pedido.estado=='Creado');
                    this.pedidos.forEach(pedido => {
                        //console.log(pedido);
                        let canal = this.canales.find(c => c.id === pedido.canal_id);
                        if(canal){
                            pedido.canal_name=canal.name
                        }else{
                            pedido.canal_name='No Definido'
                        }
                        // let turno = this.turnos.find(c => c.id === pedido.turno_id);
                        // if(turno){
                        //     pedido.turno_name=turno.name
                        // }else{
                        //     pedido.turno_name='No Definido'
                        // }
                    });
                })
                
                .catch(error => {
                    console.error('Error fetching pedidos:', error);
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading=false
            }
        },
        fecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
        hora(fechahora){
            var orden = moment(fechahora).format('HH:mm:ss');
            return orden
        },
        pedido_pagado(pedido){
            try {
                this.isLoading=true
                axios.post('/api/pedido_pagado', pedido).then(res => {
                    console.log('Order Update:', res.data.pedido);
                    //this.fetchOrders();
                    this.get_data()
                    this.fetchOrders();
                    this.isLoading=false    
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading=false    
            }
        },
        pedido_finalizado(pedido){
            try {
                this.isLoading=true
                axios.post('/api/pedido_finalizado', pedido).then(res => {
                    console.log('Order Update:', res.data.pedido);
                    //this.fetchOrders();
                    this.get_data()
                    this.fetchOrders();
                    this.isLoading=false    
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading=false    
            }
        },
    },
    mounted(){
        axios.get('/api/inventarios').then(res=>{
            this.articulos = res.data.datos;
            this.canales = res.data.canales;
        });
        this.get_data();
        this.intervalo = setInterval(() => {
            this.get_data();
        }, 15000);
        // this.pedidos = this.pedidos.filter(ped =>ped.estado!='Entregado')
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class>
                    <div class="table-responsive">
                        <table class="table project-list-table table-nowrap table-centered table-borderless">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 100px">Nº Pedido</th>
                                    <th scope="col">Productos</th>
                                    <th scope="col"><i class="bx bx-calendar mr-1"></i> Fecha </th>
                                    <th scope="col"><i class="bx bx-time-five mr-1"></i>Hora</th>
                                    <th scope="col">Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(grid,index) in pedidos" :key="index">
                                    <td>
                                        {{grid.id}}
                                    </td>
                                    <td>
                                        <div v-for="(producto,index1) in grid.productos" :key="index1">
                                            <h5 class="text-truncate font-size-14">
                                                <a href="javascript: void(0);" class="text-dark">{{producto.name}}</a>
                                            </h5>
                                            <p class="text-muted mb-0" v-show="producto.pivot.comentario!=''">{{producto.pivot.comentario}}</p>
                                        </div>
                                    </td>
                                    <td>{{fecha(grid.created_at)}}</td>
                                    <td>{{hora(grid.created_at)}}</td>
                                    <td>
                                        <span
                                        class="badge"
                                        :class="{ 'badge-primary': `${grid.estado}` == 'Finalizado',
                                    'badge-warning': `${grid.estado}` == 'Pagado',
                                    'badge-danger': `${grid.estado}` == 'Creado' }"
                                        >{{grid.estado}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>